module.exports = __webpack_public_path__ + "img/symphony_512_cherry.dbae8913.jpg";